import { render, staticRenderFns } from "./ItsuErrors.vue?vue&type=template&id=39aa73ca&scoped=true&"
import script from "./ItsuErrors.vue?vue&type=script&lang=js&"
export * from "./ItsuErrors.vue?vue&type=script&lang=js&"
import style0 from "./ItsuErrors.vue?vue&type=style&index=0&id=39aa73ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39aa73ca",
  null
  
)

export default component.exports